export default __webpack_public_path__ + "static/media/step2_1.96ecf9d6.png";